<div class="main-page">
  <ion-split-pane when="lg" contentId="main">
    <ion-menu contentId="main" style="--background: transparent">
      <ion-content
        style="
          border-radius: 0 24px 24px 0 !important;
          overflow: hidden !important;
        "
      >
        <div class="d-flex flex-column h-100">
          <div class="flex-grow-1">
            <div class="row mb-4 justify-content-center align-items-center">
              <div class="col text-center py-4">
                @if(currentOrganisationId !== 'admin' &&
                currentOrganisation?.type === 'europiscine'){
                <div
                  class="entreprise-button d-inline-block p-2"
                  (click)="openPopover($event)"
                >
                  <img
                    style="
                      height: 100%;
                      width: 100%;
                      object-fit: contain;
                      object-position: center center;
                    "
                    src="/assets/ecosystem/images/brands/europiscine/europiscine_small@2x.png"
                    alt="ACWA Connect"
                  />
                </div>
                } @else if(currentOrganisationId !== 'admin'){
                <div
                  class="entreprise-button-without-logo d-inline-block p-2"
                  (click)="openPopover($event)"
                >
                  <div class="row h-100 align-items-center">
                    <div class="col-12 text-center fw-bold">
                      @if(this.currentOrganisation){ {{
                      this.currentOrganisation!.name!.substr(0,1).toUpperCase()
                      }} }
                    </div>
                  </div>
                </div>
                } @else{
                <div
                  class="entreprise-button d-inline-block p-2"
                  (click)="openPopover($event)"
                >
                  <img
                    style="
                      height: 100%;
                      width: 100%;
                      object-fit: contain;
                      object-position: center center;
                    "
                    src="/assets/images/logo@3x.png"
                    alt="ACWA Connect"
                  />
                </div>
                }
              </div>
            </div>
            <ion-list lines="none" class="main-menu">
              @for (menu of menuConfig.primaryMenu; track menu) {
              <ion-item
                [button]="true"
                detail="false"
                class="pointer-hover"
                (click)="goTo(menu.route!)"
                (mouseenter)="onMenuMouseEnter($event,menu.tooltip || '')"
                (mouseleave)="onMenuMouseLeave($event)"
                [class.active]="uriContains(menu.route!)"
              >
                @if(menu.icon){
                <div style="width: 30px; text-align: center">
                  <i [class]="menu.icon"></i>
                </div>
                }
              </ion-item>
              }
            </ion-list>
          </div>
          <div>
            <div class="pb-4">
              <ion-list lines="none" class="main-menu">
                @for (menu of menuConfig.secondaryMenu; track menu) {
                <ion-item
                  [button]="true"
                  detail="false"
                  (click)="goTo(menu.route!)"
                  (mouseenter)="onMenuMouseEnter($event,menu.tooltip || '')"
                  (mouseleave)="onMenuMouseLeave($event)"
                  [class.active]="uriContains(menu.route!)"
                >
                  @if(menu.icon){
                  <div style="width: 30px; text-align: center">
                    <i [class]="menu.icon"></i>
                  </div>
                  }
                </ion-item>
                }
              </ion-list>
            </div>
            <div
              class="pointer-hover d-none d-lg-block pb-4 text-center"
              (click)="goTo('/')"
            >
              <img
                style="height: 36px"
                src="/assets/images/logo@3x.png"
                alt="ACWA Connect"
              />
            </div>
          </div>
        </div>
      </ion-content>
    </ion-menu>

    <div class="ion-page bg-background-secondary" id="main">
      <ion-content class="ion-padding">
        <ion-router-outlet [animated]="false"></ion-router-outlet>
      </ion-content>
    </div>
  </ion-split-pane>

  <ion-popover
    #popover
    (ionPopoverDidPresent)="popOverState(true)"
    (ionPopoverDidDismiss)="popOverState(false)"
    side="bottom"
    alignment="start"
    [arrow]="false"
    [showBackdrop]="false"
    mode="ios"
    class="organisation-popover"
  >
    <ng-template>
      <div class="organisation-content">
        <div class="px-4 py-2 organisation-border-top">
          <ion-list lines="none" class="profil-menu">
            @if(!isAdmin(this.getCurrentUser())){ @for(company of
            this.getCompanies(); track company) {
            <ion-item
              [button]="true"
              detail="false"
              (click)="goToEntrepriseSpace(company); dismissPopover();"
            >
              <div [slot]="'start'"><i class="fa-regular fa-building"></i></div>
              <ion-label>{{ company.name }}</ion-label>
            </ion-item>
            } } @if(!this.isAdminSpace && this.currentUserIsAdmin()){
            <ion-item
              [button]="true"
              detail="false"
              (click)="returnToAdmin(); dismissPopover();"
            >
              <div [slot]="'start'"><i class="fa-regular fa-building"></i></div>
              <ion-label>{{ 'menu.backToAdmin' | translate}}</ion-label>
            </ion-item>
            }

            <ion-item
              [button]="true"
              detail="false"
              (click)="goToProfil(); dismissPopover();"
            >
              <div [slot]="'start'"><i class="fa-regular fa-user"></i></div>
              <ion-label>{{ getCurrentUser()?.name }}</ion-label>
            </ion-item>
            <ion-item
              [button]="true"
              detail="false"
              color="danger"
              (click)="logout()"
            >
              <div [slot]="'start'">
                <i class="fa-regular fa-right-from-bracket"></i>
              </div>
              <ion-label style="--color: inherit !important"
                >{{ 'menu.logout' | translate }}</ion-label
              >
            </ion-item>
          </ion-list>
        </div>
      </div>
    </ng-template>
  </ion-popover>
</div>
